import {http} from '@/helpers/http-helper';

export const getRoles = () => {
    return new Promise( (resolve, reject) => {
        const url = 'roles';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createRole = (role) => {
    return new Promise( (resolve, reject) => {
        const url = 'roles';
        http.post(url, role)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateRole = (uuid, role) => {
    return new Promise( (resolve, reject) => {
        const url = 'roles/' + uuid;
        http.post(url, role)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getRole = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'roles/' + uuid;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};